// import { Link } from 'react-router-dom'
import React from "react";
import Bradcom from "../Bradcom/Main";
import First from "../Mencontact/First";
// import Newsletter from '../Menpages/Menfaq/Newsletter'
import { Helmet } from "react-helmet-async";

const Main = () => {
  return (
    <>
      <Helmet>
        <title>Hotel La Finca Zotoluca | Contacto</title>
        <meta
          name="description"
          content="medios de contacto y ubicación del hotel para tu conveniencia"
        />
      </Helmet>
      <main>
        <Bradcom title={"Contacto"} subtitle={"Inicio"} newtitle={"Contacto"} />
        <First />
        {/* <Newsletter/> */}
      </main>
    </>
  );
};

export default Main;
